(function () {

// Prevent multiple script executions
if (window.exoBASliderLoaded) {
  console.warn("ExoBA Slider already loaded, skipping...");
  return;
}
window.exoBASliderLoaded = true;

function clamp(n, min, max) { return Math.max(min, Math.min(max, n)); }

function mountSlider(root) {

  if (root.dataset.mounted === "1") {
    console.log("Slider already mounted, skipping");
    return;
  }
  
  if (root.querySelector(".exo-ba__frame")) {
    console.log("Slider frame already exists, skipping");
    root.dataset.mounted = "1";
    return;
  }

  const before = root.dataset.before;
  const after = root.dataset.after;

  if (!before || !after) {
    console.error("Missing before or after image URLs");
    return;
  }

  const beforeAlt = root.dataset.beforeAlt || "Before";
  const afterAlt = root.dataset.afterAlt || "After";

  root.innerHTML = "";
  root.dataset.mounted = "1";

  // SWAPPED: After layer is now FIRST (bottom), Before layer is SECOND (top)
  root.innerHTML = `
    <div class="exo-ba__frame" role="group" aria-label="Before and after image comparison">
      <div class="exo-ba__img exo-ba__after">
        <img loading="eager" src="${after}" alt="${afterAlt}">
      </div>
      <div class="exo-ba__img exo-ba__before">
        <img loading="eager" src="${before}" alt="${beforeAlt}">
      </div>
      <div class="exo-ba__handle" aria-hidden="true"></div>
      <div class="exo-ba__knob" role="slider" aria-valuemin="0" aria-valuemax="100" aria-valuenow="50" tabindex="0">
        <div class="exo-ba__bars" aria-hidden="true">
          <span></span><span></span><span></span>
        </div>
      </div>
    </div>
  `;

  const frame = root.querySelector(".exo-ba__frame");
  const beforeLayer = root.querySelector(".exo-ba__before");
  const handle = root.querySelector(".exo-ba__handle");
  const knob = root.querySelector(".exo-ba__knob");
  const images = root.querySelectorAll("img");

  if (!frame || !beforeLayer || !handle || !knob) {
    console.error("Failed to create slider elements");
    return;
  }

  let pct = 50;

  function render() {
    // Now clipping the BEFORE layer to show from 0 to pct
    beforeLayer.style.clipPath = `polygon(0 0, ${pct}% 0, ${pct}% 100%, 0 100%)`;
    handle.style.left = `${pct}%`;
    knob.style.left = `${pct}%`;
    knob.setAttribute("aria-valuenow", String(Math.round(pct)));
  }

  function setFromClientX(clientX) {
    const rect = frame.getBoundingClientRect();
    const x = clamp(clientX - rect.left, 0, rect.width);
    pct = (x / rect.width) * 100;
    render();
  }

  let dragging = false;

  function onDown(e) {
    dragging = true;
    knob.focus();
    const x = e.touches ? e.touches[0].clientX : e.clientX;
    setFromClientX(x);
    e.preventDefault();
  }

  function onMove(e) {
    if (!dragging) return;
    const x = e.touches ? e.touches[0].clientX : e.clientX;
    setFromClientX(x);
    e.preventDefault();
  }

  function onUp() { dragging = false; }

  frame.addEventListener("mousedown", onDown);
  frame.addEventListener("touchstart", onDown, { passive: false });
  window.addEventListener("mousemove", onMove);
  window.addEventListener("touchmove", onMove, { passive: false });
  window.addEventListener("mouseup", onUp);
  window.addEventListener("touchend", onUp);

  knob.addEventListener("keydown", (e) => {
    const step = e.shiftKey ? 10 : 2;
    if (e.key === "ArrowLeft") { pct = clamp(pct - step, 0, 100); render(); }
    if (e.key === "ArrowRight") { pct = clamp(pct + step, 0, 100); render(); }
  });

  let loadedCount = 0;
  images.forEach(img => {
    if (img.complete) {
      loadedCount++;
    } else {
      img.addEventListener("load", () => {
        loadedCount++;
        if (loadedCount === images.length) {
          render();
        }
      });
    }
  });

  render();
  setTimeout(render, 100);
  
  console.log("Slider mounted successfully");
}

function init() {
  console.log("Initializing ExoBA sliders...");
  const sliders = document.querySelectorAll(".exo-ba");
  console.log(`Found ${sliders.length} sliders`);
  sliders.forEach(mountSlider);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}

})();